import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'
import { Arrow } from '@/svgs.js'

const EventCard = ({
  title,
  imageId,
  eventType,
  eventLink,
  eventDate,
  eventLocation,
  past,
  upcoming
}) => (
  <div className={cx('event__single x', {
    'e-small': !upcoming
  })}>
    <div className='container--xl al mxa p15'>
      <div className='container--ev rel'>
        <div className='event__single-inner'>
          <div className={cx('inline-block rel x pr1 event__single-image', {
            'large': upcoming
          })}>
            <Image width={400} imageId={imageId} alt={title} />
          </div>
          <div className='inline-block event__single-info abs top'>
            <h5 className='caps x-small m0 p0 medium'>
              Next Event - {eventDate}<br />
              {eventLocation}<br />
              {eventType && (eventType.title)}
            </h5>
          </div>
          <h3 className={cx('m0  inline event__single-text ml05 p0', {
            'h1': upcoming
          })}>{title}</h3>
        </div>
        <div className='event__single-tickets top right f jcs aic mt1'>
          {!past && (
            <a className='event__single-link h5 small caps medium f jcc aic' href={eventLink} rel='noopener noreferrer' target='_blank'>
              Get Tickets <Arrow className='ml05' />
            </a>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default EventCard